import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {TranslationValue} from '../../../generated/sales-terminal-client';

@Component({
  selector: 'app-label-value',
  templateUrl: './label-value.component.html',
  styleUrls: ['./label-value.component.scss']
})
export class LabelValueComponent {
  @Input() public label: string;
  @Input() public labelClass: string = 'bold break-word';
  @Input() public required: boolean;
  @Input() public noValue: boolean;
  @Input() public value: TranslationValue[] | string | number;
  @Input() public link: boolean;
  @Input() public icon: string;
  @Input() public openTab: boolean;
  @Input() public template: TemplateRef<any>;
  @Input() public empty: boolean; // Show empty line instead of template
  @Input() public withMargin: boolean;
  @Input() public singleLine: boolean;
  @Input() public tooltip: string;
  @Output() public linkAction: EventEmitter<any> = new EventEmitter<any>();
}
